module.exports = {

    /**
     * @param   {string} string
     * @returns {string}
     */
    escape: function (string) {
        let entityMap = {
            '&':  '&amp;',
            '<':  '&lt;',
            '>':  '&gt;',
            '"':  '&quot;',
            '\'': '&#39;',
            '/':  '&#x2F;'
        };

        return String(string).replace(/[&<>"'\/]/g, function (s) {
            return entityMap[s];
        });
    },

    /**
     * @param   {string} string
     * @param   {number} length
     * @returns {string}
     */
    trim: function (string, length) {
        if (string.length > length) {
            let trimmedString = string.substr(0, length);
            return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))) + '...';
        }

        return string;
    }
};
